function toFiniteNumber(value, fallback = 0) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function clampScore(value) {
  if (!Number.isFinite(value)) return 0;
  if (value < 0) return 0;
  if (value > 100) return 100;
  return Math.round(value);
}

export function calculateGuardianStability({
  portfolio = [],
  stocks = [],
  marketData = {},
} = {}) {
  const safePortfolio = Array.isArray(portfolio) ? portfolio : [];
  const safeStocks = Array.isArray(stocks) ? stocks : [];

  const avgStockScore =
    safeStocks.length > 0
      ? safeStocks.reduce((sum, stock) => sum + toFiniteNumber(stock?.hqsScore, 55), 0) /
        safeStocks.length
      : 55;

  const totalPositionValue = safePortfolio.reduce((sum, position) => {
    const shares = toFiniteNumber(position?.shares, 0);
    const price = toFiniteNumber(position?.currentPrice ?? position?.buyPrice, 0);
    return sum + shares * price;
  }, 0);

  const maxPositionWeight =
    totalPositionValue > 0
      ? safePortfolio.reduce((maxWeight, position) => {
          const shares = toFiniteNumber(position?.shares, 0);
          const price = toFiniteNumber(position?.currentPrice ?? position?.buyPrice, 0);
          const weight = (shares * price) / totalPositionValue;
          return Math.max(maxWeight, weight);
        }, 0)
      : 0;

  const concentrationPenalty = Math.max(0, maxPositionWeight - 0.35) * 40;
  const diversificationBonus = Math.min(safePortfolio.length, 12) * 1.4;

  const volatilityLevel = String(marketData?.volatilityLevel || "normal").toLowerCase();
  const volatilityPenalty =
    volatilityLevel === "high" ? 10 : volatilityLevel === "low" ? -3 : 0;

  const stabilityScore = avgStockScore + diversificationBonus - concentrationPenalty - volatilityPenalty;
  return clampScore(stabilityScore);
}
